import { TBitValue, TReactSetState } from "../../data/AppType";
import {
  decryptData,
  handleError,
  sweetAlertError,
} from "../../utils/AppFunctions";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { GET_FIRM_BY_ID } from "../../services/Endpoints";

interface IAddress {
  id: string;
  address_line1: string;
  address_line2: string;
  address_line3: string | null;
  city: string;
  zip_code: number;
  state_name: string;
  country_name: string;
}

export interface IFirmForm {
  id: string;
  firm_name: string;
  contact_person_name: string;
  contact_person_mobile: string;
  contact_person_email: string;
  firm_type: string;
  is_active: TBitValue;
  created_date?: string;
  modified_date?: string;
  created_by?: string;
  modified_by?: string;
  address: IAddress | null;
}

export const fetchFirmId = async (
  id: string,
  handleClose: (status: boolean) => void,
  setFirm: TReactSetState<IFirmForm | undefined>
) => {
  try {
    const firmData = await GET_FIRM_BY_ID(id);
    if (firmData && firmData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      const data = JSON.parse(decryptData(firmData.data));
      setFirm(data);
    } else {
      handleClose(false);
      sweetAlertError({
        message: firmData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleClose(false);
    handleError(e, "fetchFirmId");
  }
};
